import produce from 'immer';
import { omit } from 'lodash';
import { network } from 'services/network';

export const getFilteredCards = (params) => {
    // delete unnecessary props for Api (this props needed only for FE)
    const fixedParams = produce(params, (draft) => {
        draft.filter.filters.forEach((item) => {
            omit(item, ['currentValue', 'isSelected']);
            return item;
        });
    });
    // ==========================================================================

    return network.post('api/bo/getFilteredCards', fixedParams).then((response) => {
        return response.data;
    });
};
